/**
 * API endpoint constants
 */

// Loan endpoints
export const ENDPOINT_LOANS = '/loans';
export const ENDPOINT_LOAN_INFO = '/loan-info/{loanId}';
export const ENDPOINT_LOAN_STATEMENTS = '/statements/loan/{loanId}';
export const ENDPOINT_STATEMENT_DOWNLOAD = '/statements/{loanId}/download/{rowId}/pdf';

// Payment endpoints
export const ENDPOINT_HISTORIC_PAYMENTS = '/historic-payments/{loanId}';
export const ENDPOINT_PAYMENTS = '/achs';
export const ENDPOINT_RECURRING_PAYMENTS = '/achs/{recurringPaymentId}';
export const ENDPOINT_UPCOMING_PAYMENTS = '/upcoming-payments/{loanId}';
export const ENDPOINT_PENDING_PAYMENTS = '/pending-payments/{loanId}';


// Wallet endpoints
export const ENDPOINT_WALLETS = '/wallets';

// Bank endpoints
export const ENDPOINT_BANK_LOOKUP = '/bank/lookup/{routingNumber}';

// Auth endpoints  
export const ENDPOINT_LOGIN = '/login';
export const ENDPOINT_LOGOUT = '/logout';
export const ENDPOINT_VALIDATE = '/validate';
export const ENDPOINT_REFRESH = '/refresh';
export const ENDPOINT_REGISTER = '/register';
export const ENDPOINT_PASSWORD_FORGOT = '/password-reset/forgot';
export const ENDPOINT_PASSWORD_RESET = '/password-reset/reset';
export const ENDPOINT_PASSWORD_TOKEN = '/password-reset/{token}';
export const ENDPOINT_PASSWORD_CHANGE = '/password/change';
export const ENDPOINT_USERNAME_RECOVER = '/username/recover';

// Debit / IPOSPAY
export const ENDPOINT_IPOSPAY_FTD_TOKEN = '/ipospay/token'; // <- pick the actual route your API exposes
export const ENDPOINT_IPOSPAY_DEBIT = '/ipospay/debit';